import { useState } from 'react';
import { theme } from '../theme';

export function CopyBtn({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        navigator.clipboard?.writeText(value).catch(() => {});
        setCopied(true);
        setTimeout(() => setCopied(false), 1100);
      }}
      title={copied ? 'Copied' : 'Copy'}
      style={{
        background: 'transparent', border: 'none', cursor: 'pointer',
        padding: '2px 6px', color: copied ? theme.ok : theme.veryDim,
        display: 'inline-flex', alignItems: 'center', lineHeight: 1,
        transition: 'color 140ms',
      }}
      onMouseEnter={(e) => { if (!copied) e.currentTarget.style.color = theme.accent; }}
      onMouseLeave={(e) => { if (!copied) e.currentTarget.style.color = theme.veryDim; }}
    >
      {copied ? (
        <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
          <path d="M2.5 6.2 L5 8.5 L9.5 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
          <rect x="3.5" y="3.5" width="6" height="7" rx="1" stroke="currentColor" strokeWidth="1.1" />
          <path d="M5.5 3.5 V2 a1 1 0 0 1 1 -1 H10 a1 1 0 0 1 1 1 V7 a1 1 0 0 1 -1 1 H9.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
      )}
    </button>
  );
}
